import { useNavigate } from 'react-router';
import { Switch, useToast } from '@efira/ui';

import { useMe } from '../../api/queries';

/**
 * Водяной знак.
 *
 * НА БЕСПЛАТНОМ ТАРИФЕ ВЫКЛЮЧИТЬ НЕЛЬЗЯ, и это сказано прямо, без
 * запугивания: знак - часть соглашения, по которому бесплатный тариф вообще
 * существует (SPEC 173). Тумблер не «ломается» при нажатии и не отключается
 * молча: он остаётся включённым, а нажатие ведёт туда, где написано, что
 * входит в Pro.
 *
 * Решение о показе принимает СЕРВЕР (`plan.watermark`), а не клиент: иначе
 * знак снимался бы правкой флага в браузере.
 */
export function Watermark() {
  const me = useMe();
  const navigate = useNavigate();
  const toast = useToast();

  const forced = me.data?.user?.plan.watermark === true;

  /*
   * ПОКА ТАРИФ НЕ ПРИЕХАЛ, ОРГАН НЕ РАБОТАЕТ - И ЭТО ВИДНО.
   *
   * Прежняя редакция оставляла тумблер живым: до ответа сервера `forced`
   * ложно, обработчик молча выходил, и нажатие не делало НИЧЕГО. Поймано
   * сквозным сценарием, который нажал раньше, чем приехал ответ, - то есть
   * ровно так, как это делает человек на медленной сети.
   */
  const known = me.data?.user?.plan !== undefined;

  return (
    <div data-watermark="root" className="flex max-w-xl flex-col gap-5">
      <header className="flex flex-col gap-1">
        <h2 className="text-foreground text-xl font-semibold">Водяной знак</h2>
        <p className="text-foreground/80 text-sm">Надпись платформы в углу оверлея.</p>
      </header>

      <p data-watermark="text" className="text-foreground/90 text-sm">
        В углу оверлея стоит маленькая надпись «Efira Live». Она в охранной зоне TikTok — не
        перекрывает ни игру, ни интерфейс приложения, и зритель видит, где взять такую же игру.
      </p>

      {/* Тот же вид, что у строки аккаунта TikTok: карточка с рамкой, текст
          слева, орган у правого края. Голый текст на фоне окна читался как
          обрывок абзаца, а не как управление. */}
      <label
        data-watermark="toggle-row"
        data-control-row="watermark-toggle"
        className="border-foreground/10 rounded-lg @container flex items-center gap-3 border p-3 text-sm"
      >
        <Switch
          data-watermark="toggle"
          checked
          disabled={!known}
          onCheckedChange={() => {
            if (!forced) {
              return;
            }

            /* Тумблер ОСТАЁТСЯ включённым: `checked` задан жёстко, и
               обработчик его не меняет - мы не делаем вид, что выбор
               произошёл. Нажатие ведёт туда, где написано, что даёт Pro. */
            toast.show({
              tone: 'neutral',
              title: 'Знак остаётся на бесплатном тарифе',
              text: 'Так работает бесплатный доступ: платформа видна на оверлее.',
            });
            void navigate('/app/plan?from=watermark');
          }}
          className="order-2 shrink-0"
        />
        <span className="order-1 flex min-w-0 flex-1 flex-col">
          <span className="text-foreground text-base font-semibold">
            Показывать знак на оверлее
          </span>
          <span className="text-foreground/90 text-sm">
            {forced
              ? 'На бесплатном тарифе знак включён всегда — это условие бесплатного доступа. В Pro его можно снять.'
              : 'В вашем тарифе знак можно снять.'}
          </span>
        </span>
      </label>
    </div>
  );
}
